// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__ZpwKt","icon":"SortAdornment_icon__1sLuS","up":"SortAdornment_up__2D9yv","down":"SortAdornment_down__13-ck","active":"SortAdornment_active__2vArK"};